import type { PermissionAction } from '../types';
import { SCHEDULER_RESOURCES, type SchedulerResourceId } from './resources';

export interface SchedulerActionPermission {
  resourceId: SchedulerResourceId | string;
  action: PermissionAction;
}

export const SCHEDULER_ACTION_PERMISSIONS = {
  importRun: {
    resourceId: SCHEDULER_RESOURCES.scheduleImport,
    action: 'create' as PermissionAction,
  },
  locationCreate: {
    resourceId: SCHEDULER_RESOURCES.scheduleLocations,
    action: 'create' as PermissionAction,
  },
  locationEdit: {
    resourceId: SCHEDULER_RESOURCES.scheduleLocations,
    action: 'edit' as PermissionAction,
  },
  locationDelete: {
    resourceId: SCHEDULER_RESOURCES.scheduleLocations,
    action: 'delete' as PermissionAction,
  },
  taskCreate: {
    resourceId: SCHEDULER_RESOURCES.scheduleTasks,
    action: 'create' as PermissionAction,
  },
  taskEdit: {
    resourceId: SCHEDULER_RESOURCES.scheduleTasks,
    action: 'edit' as PermissionAction,
  },
  taskDelete: {
    resourceId: SCHEDULER_RESOURCES.scheduleTasks,
    action: 'delete' as PermissionAction,
  },
  taskApprove: {
    resourceId: SCHEDULER_RESOURCES.scheduleTasks,
    action: 'approve' as PermissionAction,
  },
  /** Set project baseline — create or edit on tasks */
  taskSetBaseline: {
    resourceId: SCHEDULER_RESOURCES.scheduleTasks,
    action: 'create' as PermissionAction,
  },
  calendarCreate: {
    resourceId: SCHEDULER_RESOURCES.scheduleCalendar,
    action: 'create' as PermissionAction,
  },
  calendarEdit: {
    resourceId: SCHEDULER_RESOURCES.scheduleCalendar,
    action: 'edit' as PermissionAction,
  },
  calendarDelete: {
    resourceId: SCHEDULER_RESOURCES.scheduleCalendar,
    action: 'delete' as PermissionAction,
  },
} as const satisfies Record<string, SchedulerActionPermission>;

export type SchedulerActionPermissionKey = keyof typeof SCHEDULER_ACTION_PERMISSIONS;
